'use strict';

var App = require('app');
var AppState = require('app_state');
var Notification = require('utils/notification');
var i18n = require('utils/i18n');

var DevicesStatus = Backbone.Model.extend({
    urlRoot: '/api/v1/devices/status',
});

var API = {
    setDeviceStatus: function (status, deviceID) {
        App.ajax({
            url: '/api/v1/devices/' + deviceID + '/status',
            type: 'POST',
            data: JSON.stringify({ status: status, device_id: deviceID }),
            dataType: 'json',
            success: function () {
                Notification.show(
                    'success',
                    i18n.TR('Erfolg'),
                    status === 0 ? i18n.TR('Gerät wurde aktiviert.') : i18n.TR('Gerät wurde deaktivert.')
                );
                var currentFragment = Backbone.history.getFragment();
                Backbone.history.loadUrl(currentFragment);
            },
            error: function () {
                Notification.show(
                    'error',
                    i18n.TR('Fehler'),
                    status === 0
                        ? i18n.TR('Gerät konnte nicht aktiviert werden.')
                        : i18n.TR('Gerät konnte nicht deaktiviert werden.')
                );
            },
        });
    },

    lastStatusFetch: {
        time: 0,
        result: undefined,
    },

    getDevicesStatus: function () {
        var status = new DevicesStatus({});
        var defer = $.Deferred();

        var self = this;
        var time = new Date().getTime();
        if (time - this.lastStatusFetch.time < 10 * 1000 || AppState.isFullScreen) {
            // return last status fetch result
            defer.resolve(this.lastStatusFetch.result);
            return defer.promise();
        }

        status.fetch({
            success: function (data) {
                // cache results
                self.lastStatusFetch = {
                    time: time,
                    result: data,
                };

                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('devices:status', function () {
    return API.getDevicesStatus();
});

App.reqres.setHandler('device:status:set', function (status, deviceID) {
    return API.setDeviceStatus(status, deviceID);
});

module.exports = DevicesStatus;
